import React from 'react';
import { motion } from 'framer-motion';
export function Hook() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="hook-title" data-id="element-83" data-mp="2b6buq93aaxri">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[1fr_0.85fr]" data-id="element-84" data-mp="2b48u6v4i9m8j">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.5
      }} data-id="element-85" data-mp="1x8nan3h1juni">
          <h2 id="hook-title" className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-86" data-mp="2txcsitso4n9h">
            ¿Alguna vez viste esos muñequitos tejidos tan tiernos y pensaste “yo nunca voy a poder
            hacer eso”?
          </h2>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-muted" data-id="element-87" data-mp="2k572hplz8fwx">
            <p data-id="element-88" data-mp="37vsxogavu5pi">
              Tal vez lo intentaste viendo tutoriales de YouTube que van demasiado rápido. Tal vez
              terminaste con un tejido lleno de agujeros, una cabeza deforme o, peor aún, te
              rendiste porque no entendías los diagramas en otro idioma.
            </p>
          </div>

          <blockquote className="mt-8 border-l-4 border-terracotta bg-cream px-6 py-5" data-id="element-89" data-mp="2535uqib080kn">
            <p className="font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-90" data-mp="2jr90bql4xa8x">
              Tejer amigurumis no es difícil. Lo difícil es intentar aprender sin un método
              ordenado.
            </p>
          </blockquote>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.6
      }} className="overflow-hidden rounded-[2rem] shadow-soft" data-id="element-91" data-mp="2oq3hyp7d8srg">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/31269718-4111-4d26-b0b7-bca30fb06864.jpg" alt="Manos tejiendo un amigurumi con lana verde menta y aguja de madera" className="h-full w-full object-cover" data-id="element-92" data-mp="18aipfu5rnu8z" />
        </motion.div>
      </div>
    </section>;
}